// Complete World & African Countries, States/Counties, and Districts/Cities Data

export const WORLD_COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Antigua and Barbuda", "Argentina", "Armenia", "Australia", "Austria",
  "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bhutan",
  "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia",
  "Cameroon", "Canada", "Central African Republic", "Chad", "Chile", "China", "Colombia", "Comoros", "Congo", "Costa Rica",
  "Croatia", "Cuba", "Cyprus", "Czech Republic", "Democratic Republic of the Congo", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador",
  "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Fiji", "Finland", "France",
  "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Greece", "Grenada", "Guatemala", "Guinea", "Guinea-Bissau",
  "Guyana", "Haiti", "Holy See (Vatican City)", "Honduras", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq",
  "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica", "Japan", "Jordan", "Kazakhstan", "Kenya", "Kiribati",
  "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania",
  "Luxembourg", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands", "Mauritania", "Mauritius",
  "Mexico", "Micronesia", "Moldova", "Monaco", "Mongolia", "Montenegro", "Morocco", "Mozambique", "Myanmar", "Namibia",
  "Nauru", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Niger", "Nigeria", "North Korea", "North Macedonia", "Norway",
  "Oman", "Pakistan", "Palau", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland",
  "Portugal", "Qatar", "Romania", "Russia", "Rwanda", "Saint Kitts and Nevis", "Saint Lucia", "Saint Vincent and the Grenadines", "Samoa", "San Marino",
  "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands",
  "Somalia", "South Africa", "South Korea", "South Sudan", "Spain", "Sri Lanka", "Sudan", "Suriname", "Sweden", "Switzerland",
  "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor-Leste", "Togo", "Tonga", "Trinidad and Tobago", "Tunisia",
  "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "United States", "Uruguay", "Uzbekistan",
  "Vanuatu", "Venezuela", "Vietnam", "Yemen", "Zambia", "Zimbabwe"
];

export const STATES_BY_COUNTRY = {
  // KENYA (All 47 Counties / States)
  "Kenya": [
    "Nairobi", "Mombasa", "Kisumu", "Nakuru", "Kiambu", "Uasin Gishu (Eldoret)", "Machakos", "Kajiado",
    "Nyeri", "Kilifi", "Kwale", "Meru", "Murang'a", "Trans Nzoia (Kitale)", "Kakamega", "Bungoma", "Garissa",
    "Turkana (Lodwar)", "Laikipia", "Narok", "Kericho", "Kisii", "Embu", "Kirinyaga", "Machakos", "Makueni",
    "Nyandarua", "Nyamira", "Migori", "Homa Bay", "Siaya", "Busia", "Vihiga", "Nandi", "Bomet", "Baringo",
    "Elgeyo-Marakwet", "West Pokot", "Samburu", "Isiolo", "Marsabit", "Mandera", "Wajir", "Tana River", "Taita-Taveta", "Lamu"
  ],

  // SOUTH AFRICA
  "South Africa": [
    "Gauteng", "Western Cape", "KwaZulu-Natal", "Eastern Cape", "Free State", "Limpopo", "Mpumalanga", "North West", "Northern Cape"
  ],

  // NIGERIA
  "Nigeria": [
    "Lagos", "Abuja (FCT)", "Kano", "Rivers", "Oyo", "Kaduna", "Edo", "Ogun", "Enugu", "Delta", "Anambra", "Osun",
    "Ondo", "Akwa Ibom", "Cross River", "Imo", "Borno", "Plateau", "Kwara", "Benue", "Abia", "Bauchi", "Sokoto"
  ],

  // EGYPT
  "Egypt": [
    "Cairo", "Alexandria", "Giza", "Qalyubia", "Sharqia", "Dakahlia", "Gharbia", "Monufia", "Beheira", "Ismailia",
    "Suez", "Port Said", "Red Sea", "Luxor", "Aswan", "South Sinai", "Matrouh", "Asyut", "Faiyum", "Sohag"
  ],

  // ETHIOPIA
  "Ethiopia": [
    "Addis Ababa", "Oromia", "Amhara", "Somali", "SNNPR", "Tigray", "Sidama", "Dire Dawa", "Afar", "Benishangul-Gumuz", "Gambela", "Harari"
  ],

  // GHANA
  "Ghana": [
    "Greater Accra", "Ashanti", "Western", "Eastern", "Central", "Northern", "Volta", "Upper East", "Upper West",
    "Bono", "Bono East", "Ahafo", "Oti", "Savannah", "North East", "Western North"
  ],

  // TANZANIA
  "Tanzania": [
    "Dar es Salaam", "Dodoma", "Arusha", "Mwanza", "Kilimanjaro", "Zanzibar Urban/West", "Tanga", "Morogoro", "Mbeya", "Tabora", "Kagera", "Iringa"
  ],

  // UGANDA
  "Uganda": [
    "Central Region (Kampala)", "Eastern Region", "Northern Region", "Western Region", "Wakiso", "Mukono", "Jinja", "Gulu", "Mbarara"
  ],

  // MOROCCO
  "Morocco": [
    "Casablanca-Settat", "Rabat-Salé-Kénitra", "Tanger-Tetouan-Al Hoceima", "Marrakech-Safi", "Fès-Meknès", "Souss-Massa", "Oriental", "Béni Mellal-Khénifra"
  ],

  // ALGERIA
  "Algeria": [
    "Algiers", "Oran", "Constantine", "Annaba", "Blida", "Batna", "Sétif", "Sidi Bel Abbès", "Biskra", "Tlemcen"
  ],

  // ZIMBABWE
  "Zimbabwe": [
    "Harare", "Bulawayo", "Manicaland", "Mashonaland Central", "Mashonaland East", "Mashonaland West", "Masvingo", "Matabeleland North", "Matabeleland South", "Midlands"
  ],

  // ZAMBIA
  "Zambia": [
    "Lusaka", "Copperbelt", "Central", "Eastern", "Luapula", "Muchinga", "Northern", "North-Western", "Southern", "Western"
  ],

  // RWANDA
  "Rwanda": [
    "Kigali", "Eastern Province", "Northern Province", "Southern Province", "Western Province"
  ],

  // SENEGAL
  "Senegal": [
    "Dakar", "Thiès", "Diourbel", "Saint-Louis", "Kaolack", "Ziguinchor", "Louga", "Fatick", "Kolda"
  ],

  // MAURITIUS
  "Mauritius": [
    "Port Louis", "Plaines Wilhems", "Grand Port", "Flacq", "Black River", "Pamplemousses", "Rivière du Rempart", "Savanne"
  ],

  // INDIA
  "India": [
    "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh", "Goa", "Gujarat", "Haryana",
    "Himachal Pradesh", "Jharkhand", "Karnataka", "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur",
    "Meghalaya", "Mizoram", "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
    "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Delhi", "Chandigarh", "Puducherry", "Ladakh", "Jammu and Kashmir"
  ],

  // USA
  "United States": [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida",
    "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine",
    "Maryland", "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska",
    "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
    "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina", "South Dakota", "Tennessee",
    "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ],

  // UK
  "United Kingdom": [
    "England", "Scotland", "Wales", "Northern Ireland", "Greater London", "West Midlands", "Greater Manchester", "Yorkshire"
  ],

  // CANADA
  "Canada": [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia",
    "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan", "Northwest Territories", "Nunavut", "Yukon"
  ],

  // AUSTRALIA
  "Australia": [
    "New South Wales", "Victoria", "Queensland", "Western Australia", "South Australia", "Tasmania",
    "Australian Capital Territory", "Northern Territory"
  ],

  // UAE
  "United Arab Emirates": [
    "Abu Dhabi", "Ajman", "Dubai", "Fujairah", "Ras Al Khaimah", "Sharjah", "Umm Al Quwain"
  ],

  // SINGAPORE
  "Singapore": [
    "Central Region", "East Region", "North Region", "North-East Region", "West Region"
  ],

  // GERMANY
  "Germany": [
    "Bavaria", "Baden-Württemberg", "Berlin", "Brandenburg", "Bremen", "Hamburg", "Hesse", "Lower Saxony",
    "Mecklenburg-Vorpommern", "North Rhine-Westphalia", "Rhineland-Palatinate", "Saarland", "Saxony",
    "Saxony-Anhalt", "Schleswig-Holstein", "Thuringia"
  ],

  // FRANCE
  "France": [
    "Auvergne-Rhône-Alpes", "Bourgogne-Franche-Comté", "Brittany", "Centre-Val de Loire", "Corsica",
    "Grand Est", "Hauts-de-France", "Île-de-France", "Normandy", "Nouvelle-Aquitaine", "Occitanie",
    "Pays de la Loire", "Provence-Alpes-Côte d'Azur"
  ],

  // SAUDI ARABIA
  "Saudi Arabia": [
    "Riyadh Region", "Makkah Region", "Madinah Region", "Eastern Province", "Asir Region", "Tabuk Region",
    "Hail Region", "Jazan Region", "Najran Region", "Al-Qassim Region", "Al-Jawf Region", "Northern Borders Region"
  ],

  // JAPAN
  "Japan": [
    "Aichi", "Chiba", "Fukuoka", "Hokkaido", "Hyogo", "Kanagawa", "Kyoto", "Osaka", "Saitama", "Tokyo"
  ]
};

export const CITIES_BY_STATE = {
  // KENYA Cities / Towns
  "Nairobi": ["Nairobi City", "Westlands", "Kilimani", "Karen", "Lang'ata", "Kasaraani", "Embakasi", "Dagoretti", "Ruaraka"],
  "Mombasa": ["Mombasa City", "Nyali", "Likoni", "Changamwe", "Kisauni", "Mvita", "Jomvu"],
  "Kisumu": ["Kisumu City", "Kisumu Central", "Kisumu East", "Kisumu West", "Kenyatta", "Nyakach"],
  "Nakuru": ["Nakuru City", "Naivasha", "Gilgil", "Molo", "Njoro", "Subukia", "Rongai"],
  "Kiambu": ["Thika", "Kiambu Town", "Ruiru", "Kikuyu", "Limuru", "Karuri", "Juja"],
  "Uasin Gishu (Eldoret)": ["Eldoret", "Turbo", "Soy", "Ainabkoi", "Kapseret", "Moiben"],
  "Machakos": ["Machakos Town", "Athi River", "Mlolongo", "Kangundo", "Matungulu", "Yatta"],
  "Kajiado": ["Kitengela", "Ongata Rongai", "Kajiado Town", "Ngong", "Loitokitok"],
  "Nyeri": ["Nyeri Town", "Karatina", "Othaya", "Mukurweini", "Tetu"],
  "Kilifi": ["Malindi", "Kilifi Town", "Mtwapa", "Watamu", "Vipingo", "Kaloleni"],
  "Kwale": ["Ukunda", "Diani Beach", "Kwale Town", "Msambweni", "Lunga Lunga"],
  "Meru": ["Meru Town", "Maua", "Nanyuki Border", "Timau"],
  "Kakamega": ["Kakamega Town", "Mumias", "Butere", "Lugari"],
  "Garissa": ["Garissa Town", "Dadaab", "Ijara", "Balambala"],
  "Turkana (Lodwar)": ["Lodwar", "Kakuma", "Lokichogio", "Turkana South"],

  // SOUTH AFRICA Cities
  "Gauteng": ["Johannesburg", "Pretoria", "Soweto", "Sandton", "Centurion", "Midrand", "Roodepoort"],
  "Western Cape": ["Cape Town", "Stellenbosch", "George", "Paarl", "Knysna", "Hermanus", "Somerset West"],
  "KwaZulu-Natal": ["Durban", "Pietermaritzburg", "Richards Bay", "Newcastle", "Ballito", "Umhlanga"],
  "Eastern Cape": ["Gqeberha (Port Elizabeth)", "East London", "Mthatha", "Makhanda (Grahamstown)"],

  // NIGERIA Cities
  "Lagos": ["Ikeja", "Victoria Island", "Lagos Island", "Lekki", "Yaba", "Surulere", "Epe", "Badagry"],
  "Abuja (FCT)": ["Abuja City", "Garki", "Wuse", "Maitama", "Asokoro", "Gwarinpa", "Kubwa"],
  "Kano": ["Kano City", "Fagge", "Dala", "Gwale", "Kumbotso"],
  "Rivers": ["Port Harcourt", "Obio-Akpor", "Bonny", "Eleme"],

  // EGYPT Cities
  "Cairo": ["Cairo City", "Heliopolis", "Nasr City", "Maadi", "Zamalek", "New Cairo"],
  "Alexandria": ["Alexandria City", "El Montazah", "Smouha", "Borg El Arab"],
  "Giza": ["Giza City", "Dokki", "Mohandessin", "6th of October City", "Sheikh Zayed City"],

  // ETHIOPIA Cities
  "Addis Ababa": ["Bole", "Kirkos", "Arada", "Yeka", "Nifas Silk-Lafto", "Gullele"],

  // GHANA Cities
  "Greater Accra": ["Accra City", "Tema", "Madina", "East Legon", "Osu", "Spintex"],
  "Ashanti": ["Kumasi", "Obuasi", "Ejisu", "Asokwa"],

  // TANZANIA Cities
  "Dar es Salaam": ["Kinondoni", "Ilala", "Temeke", "Kigamboni", "Ubungo"],
  "Dodoma": ["Dodoma City", "Bahi", "Chamwino"],

  // UGANDA Cities
  "Central Region (Kampala)": ["Kampala City", "Nakawa", "Kawempe", "Makindye", "Rubaga"],

  // MOROCCO Cities
  "Casablanca-Settat": ["Casablanca", "Mohammedia", "El Jadida", "Settat"],
  "Rabat-Salé-Kénitra": ["Rabat", "Salé", "Kénitra", "Temara"],

  // TAMIL NADU Districts
  "Tamil Nadu": [
    "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli", "Erode", "Vellore", "Thanjavur",
    "Tuticorin", "Dindigul", "Kanchipuram", "Tiruppur", "Cuddalore", "Karur", "Nagapattinam", "Pudukkottai",
    "Ramanathapuram", "Sivaganga", "Theni", "Thoothukudi", "Tiruvallur", "Tiruvannamalai", "Tiruvarur", "Krishnagiri",
    "Ranipet", "Tenkasi", "Chengalpattu", "Kallakurichi", "Mayiladuthurai", "Porur", "Virudhunagar", "Namakkal", "Nilgiris (Ooty)"
  ],

  // MAHARASHTRA
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Aurangabad", "Solapur", "Navi Mumbai", "Kolhapur"]
};
